<template>
  <div v-if="value?.list?.amount! > value?.actual?.amount!" class="mb-4 flex items-baseline justify-between">
    <div v-t="'pages.product.price_label'" class="text-base font-light"></div>
    <VcPriceDisplay class="ml-2 text-base" :value="value?.list" />
  </div>
  <div v-if="value?.list?.amount! > value?.actual?.amount!" class="mb-4 flex items-baseline justify-between">
    <div v-t="'pages.product.discount_price_label'" class="text-base font-light"></div>
    <VcPriceDisplay class="ml-2 text-base" :value="value?.discountAmount" />
  </div>
  <div class="mb-4 flex items-baseline justify-between">
    <div v-t="'pages.product.actual_price_label'" class="text-base font-light"></div>
    <VcPriceDisplay
      v-if="value?.list?.amount! > value?.actual?.amount!"
      class="text-lg font-bold"
      :class="priceColorClass"
      :value="value?.actual"
    />
    <VcPriceDisplay v-else class="text-lg font-bold" :value="value?.list" />
  </div>
</template>

<script setup lang="ts">
import type { MoneyType, PriceType } from "@/core/api/graphql/types";

interface IProps {
  value?: PriceType | { list: MoneyType; actual: MoneyType; discountAmount: MoneyType };
  priceColorClass?: string;
  noSuffix?: boolean;
}

withDefaults(defineProps<IProps>(), {
  priceColorClass: "text-[color:var(--color-price)]",
  noSuffix: false,
});
</script>
